import React from 'react';
import { Menu, Avatar, MenuItem, Typography } from '@mui/material';
import { MdLogout, MdSwapHoriz  } from 'react-icons/md';
import { User } from "oidc-client-ts";
import { UserNameCard, OrganizationNameCard, UserInfoCardContainer } from './Header.styled';

interface UserMenuProps {
    anchorElUser: Element | null;
    handleCloseUserMenu: () => void;
    userInfo: User | null
    actorName: string | undefined;
    logOut: () => void;
    switchUser: () => void;
}

/**
 * `UserMenu` is a React functional component that renders a user profile menu using Material-UI components.
 * It takes in props such as `anchorElUser` for positioning, `handleCloseUserMenu` for closing the menu,
 * `userInfo` containing user details, `logOut` to handle the logout process and `SwitchUser` to handle switch user process. 
 * The menu displays the user's initial from their name as an avatar and shows the user's full name and organization name if available.
 */
const UserMenu: React.FC<UserMenuProps> = ({ anchorElUser, handleCloseUserMenu, userInfo, actorName, logOut, switchUser }) => {
    return (
        <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
        >
            <UserInfoCardContainer>
                <Avatar sx={{ left: 'calc(50% - 2em)', height: '4em', width: '4em', bgcolor: 'black', marginBottom: '1em' }}>
                    {userInfo?.profile?.name?.charAt(0) ? userInfo?.profile?.name?.charAt(0) : 'N'}
                </Avatar>
                <OrganizationNameCard>{userInfo?.profile?.name}</OrganizationNameCard>
                {actorName && <UserNameCard>{actorName}</UserNameCard>}
            </UserInfoCardContainer>
            <MenuItem onClick={switchUser} style={{ marginTop: '1em' }}>
                <MdSwapHoriz style={{ marginRight: '10px'}} />
                <Typography textAlign="center">Skipta um umboð</Typography>
            </MenuItem>
            <MenuItem onClick={logOut} style={{ marginTop: '1em' }}>
                <MdLogout style={{ marginRight: '10px' }} />
                <Typography textAlign="center">Skrá út</Typography>
            </MenuItem>
        </Menu>
    );
}

export default UserMenu;
